import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Select from 'react-select';
import {  Button,Modal, ModalHeader, ModalBody } from 'reactstrap';
import { adminListBlogAction, adminBlogStatusAction } from '../../../actions/Admin/Blog';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import NavMenu from '../sidebar/navBar';
import { notification } from 'antd';
import SideMenu from '../sidebar/SidebarCustom';
import ReactHtmlParser from 'react-html-parser';
import './../App.css';

class AdminListBlog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: true,
            modelAddCategory: false,
            statusChange: false,
            modelOrderChange: false,
            changeOrderReq: false,
            fieldsList: [],
            code: '',
            list: [],
            orderOption: [],
            fieldSelct: '',
            totalCount: 0,
            modelTitle: "Add Category",
            currentPage: 1,
            sizePerPage: 10,
            oldOrderChange: {},
            orderChange: {},
            viewData: {},
            formData: {},
        }
        this.statusChange = this.statusChange.bind(this);
        this.onStatus = this.onStatus.bind(this);
        this.editAction = this.editAction.bind(this);
        this.handleModel = this.handleModel.bind(this);
        this.handleModelView = this.handleModelView.bind(this);
    }


    componentDidMount() {
        this.blogList(10, 0);
    }

    blogList = (limit, page) => {
        let reqObj = {
            "limit": limit,
            "offset": page,
            "order": "orderby",
            "direction": "asc",
            "search": "",
            "status": ""
        }
        this.props.adminListBlogAction(reqObj);
    }

    componentWillReceiveProps(nextProps) {

        // if (nextProps && nextProps.blogCount) {
        //     this.setState({
        //         totalCount: nextProps.blogCount,
        //     })
        // }
        if (nextProps && nextProps.blogData && nextProps.blogData.length > 0) {
        console.log("nextProps",nextProps)
            this.setState({
                totalCount: nextProps.blogCount,
                list: nextProps.blogData
            })
        }


        if (nextProps.changeStatus && this.state.statusChange) {
            notification.success({
                message: nextProps.changeStatus.msg,
                className:'successNotification',
                duration: 3
            });
            this.setState({
                statusChange: false
            })
            this.componentDidMount();
        }
    }

    toggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }

    handleModel = (type, row, cell) => {
        let modelTitle = this.state.modelTitle;
        let formData = this.state.formData;
        if (type === "edit") {
            formData.id = row._id
            formData.name = row.name
            modelTitle = "Edit Category";
            this.setState({
                modelTitle: modelTitle,
                formData: formData
            })
        }else{
            formData ={};
            modelTitle = "Add Category";
            this.setState({
                modelTitle: modelTitle,
                formData: formData
            })
        }
        this.setState({ modelAddCategory: !this.state.modelAddCategory });
    }

  

    handleModelView = (cell, row, index) => {
        if (!this.state.modelOrderChange) {

            this.setState({
                viewData: row,
                orderChange: { value: row.orderby, label: row.orderby }
            });
        }
        this.setState({ modelOrderChange: !this.state.modelOrderChange });
    }

    statusChange(cell, row, rowIndex) {

        let reqObj = {
            id: row._id,
        }
        if (row.status === "active") {
            reqObj.status = "inactive"
        } else {
            reqObj.status = "active"
        }

        this.setState({
            statusChange: true
        })
        this.props.adminBlogStatusAction(reqObj)

    }

    orderChange(cell, row, rowIndex) {
        let reqObj = {
            id: row._id,
        }
        if (row.status === "active") {
            reqObj.status = "inactive"
        } else {
            reqObj.status = "active"
        }
        this.setState({
            statusChange: true
        })
        this.props.adminBlogStatusAction(reqObj)
    }


    handleChangeSelect = async (name, value) => {
        this.setState({
            oldOrderChange: this.state.orderChange,
            orderChange: value
        });
    }

    onStatus(cell, row, enumObject, rowIndex) {
        return (<button className="admin-active-btn" onClick={() => this.statusChange(cell, row, rowIndex)}>{row.status}</button>)
    }

    handleEdit = (type,row,cell)=>{
        this.props.history.push({
            pathname: "/admin/blog-edit/"+row._id,
            state:row
        });

    }

    editAction(cell, row, enumObject, rowIndex) {
        return (
            <span>
                <button className="admin-active-btn" onClick={() => this.handleEdit("edit", row, cell)}>Edit</button>&nbsp;
                <button className="admin-active-btn" onClick={() => this.handleModelView("view", row, cell)}>View</button>
            </span>
        )
    }

    sizePerPageListChange(sizePerPage) {
        this.setState({
            sizePerPage: sizePerPage
        })
    }

    onPageChange(page, sizePerPage) {
        console.log("page, sizePerPage", page, sizePerPage);
        this.setState({
            currentPage: page
        })
        this.blogList(sizePerPage, (page - 1));
    }

    render() {
        const { formData, list, sizePerPage, currentPage, viewData } = this.state;
        //let tableOption = TableOption;
        var tableOption = {
            onPageChange: this.onPageChange.bind(this),
            page: currentPage,
            onSizePerPageList: sizePerPage,
            paginationPosition: 'bottom', // default is bottom, top and both is all available
            alwaysShowAllBtns: true,
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last',
        };


        return (
            <div className="wrapper">
                <SideMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                <div id="content">
                    <NavMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                    {/*<div> <Button className="cary-btn" onClick={this.handleModel}> Add Blog </Button></div>*/}
                    <div className="custom-table-wrapper">
                        <BootstrapTable 
                            ref={el => (this.componentRef = el)}
                            data={list} 
                            search={ true }
                            pegination={ true }
                            remote={false}
                            options={ tableOption } fetchInfo={ { dataTotalSize: this.state.totalCount } } bordered={true} pagination striped hover condensed> 
                            <TableHeaderColumn  hidden={true} dataField='_id' isKey>object ID</TableHeaderColumn>
                            <TableHeaderColumn  tdAttr={{'data-attr':'Title' }} dataField='title'> Title </TableHeaderColumn>
                            <TableHeaderColumn width='200' tdAttr={{'data-attr':'Status' }} dataField='' dataFormat={this.onStatus}>Status</TableHeaderColumn>
                            <TableHeaderColumn  width='200' tdAttr={{'data-attr':'Action' }} dataField='' dataFormat={this.editAction}>Action</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
 
                    <Modal backdrop="static" keyboard={false} isOpen={this.state.modelAddCategory} toggle={this.handleModel} className={this.props.className}>
                        <ModalHeader toggle={this.handleModel}>{this.state.modelTitle}</ModalHeader>
                        <form  onSubmit={this.addCategory} >
                            <ModalBody>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label>Category Name</label>
                                        <input type="text" id="categoryName" name="name" className="input-field-control"  onChange={this.inputchange} placeholder="Category Name" value={formData.name} required/>
                                    </div>
                                    <div className="col-md-12">
                                        <label>Description</label>
                                        <textarea rows="4" id="descriptionCateg" name="description" className="input-field-control admin-textarea-control" onChange={this.inputchange} placeholder="Description" value={formData.description} ></textarea>
                                    </div> 
                                </div>
                                <div className="modal-btn-block">
                                  <Button type="submit" className="btn modal-save-btn">{formData&&formData.id?"Update":"Submit"}</Button>
                                  <a type="cancel" className="btn modal-cancel-btn" onClick={this.handleModel}>Cancel</a>
                                </div>
                            </ModalBody>
                        </form>    
                            {/*<Button type="cancel" onClick={this.resumeUpload}>Cancel</Button>*/}
                    </Modal>                    

                    <Modal backdrop="static" keyboard={false} isOpen={this.state.modelOrderChange} toggle={this.handleModelView} className={this.props.className}>
                    <ModalHeader toggle={this.handleModelView}>View</ModalHeader>
                     <form  onSubmit={this.updateChangeOrder} >
                        <ModalBody>
                        <div className="row">
                            <div className="col-md-8">
                                <h1 className="main-heading mt-5">Blog</h1>
                                <div className="page-content">
                                    <div className="single_blog_page">
                                        <div className="single_blog_wrap">
                                            <h3>{viewData.title}</h3>
                                            <div className="single_blog_img">
                                                <img src={process.env.REACT_APP_SERVER_IMAGE_BUCKET +"/" +viewData.image} alt="blogImage"></img>
                                            </div>
                                            <div className="single_blog_content">
                                              {ReactHtmlParser(viewData.description)}
                                            </div>
                                            <div className="blog_footer"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </ModalBody>
                    </form>    
                            {/*<Button type="cancel" onClick={this.resumeUpload}>Cancel</Button>*/}
                    </Modal>
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {

    console.log("state.blog", state.AdminBlog);
    return {
        blogCount: state.AdminBlog.response.count,
        blogData: state.AdminBlog.response.data,
       // category: state.AdminBlog.response,
        changeStatus: state.AdminBlog.responseStatus ? state.AdminBlog.responseStatus : [],
       // responseOrder: state.AdminBlog.responseOrder ? state.AdminBlog.responseOrder : []
    };
}

export default withRouter(connect(mapStateToProps, {
    adminListBlogAction,
    adminBlogStatusAction,
})(AdminListBlog));


// WEBPACK FOOTER //
// ./src/components/Admin/Blog/List.js